define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const config = require('config');

    module.exports = {
        getProductData: (name) => {
            if(typeof name !== 'string') {
                return [];
            }

            return name.split('---').map(item => item.trim());
        },

        getReferrerFromCookie: function() {
            const referrerConfig = config.get('dynamicTags.DTAG_REFERRER_CONFIG');

            if(!referrerConfig) {
                return '';
            }

            return referrerConfig.split(';').reduce((acc, current) => {
                const [customImsField = '', cookieName = ''] = current.split(':');
                const cookieValue = $.cookie(cookieName.trim());

                if(customImsField && cookieValue) {
                   acc += `${customImsField.trim()}:${cookieValue};`;
                }

                return acc;
            }, '');
        },
    };
});
